import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AboutImg from '../../images/about.png';
import SectionTitle from '../SectionTitle/SectionTitle';


const testimonials = [
    {
        id: '01',
        img: AboutImg,
        Des: "I was able to book an appointment quickly and the doctors took time to clearly explain my condition. From the reception to the consultation, everyone was kind and professional. I felt very safe throughout my treatment.\u201D",
        title: 'Tharushi Perera',
        sub: "Colombo, Sri Lanka",
    },
    {
        id: '02',
        img: AboutImg,
        Des: "\u201CThe staff here treated me like family. They listened to all my concerns and gave me a treatment plan that really worked. I\u2019m grateful for the care I received and would happily recommend this hospital to anyone.\u201D",
        title: 'Nuwan Jayasinghe',
        sub: "Kandy, Sri Lanka",
    },
    {
        id: '03',
        img: AboutImg,
        Des: "\u201CI travelled from out of town for a specialist consultation and was impressed by the modern facilities and friendly team. The follow\u2011up care and support after my visit were truly excellent.\u201D",
        title: 'Dilini Fernando',
        sub: "Galle, Sri Lanka",
    },
    {
        id: '04',
        img: AboutImg,
        Des: "\u201CFrom the moment I walked in, the warm atmosphere put me at ease. The doctor was thorough and patient, answering every question I had. The pharmacy and lab services were efficient and well organized.\u201D",
        title: 'Kasun Wijeratne',
        sub: "Matale, Sri Lanka",
    },
];


const Testimonial = (props) => {

    const settings = {
        dots: false,
        autoplay: true,
        infinite: true,
        arrows: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    dots: true,
                },
            },
        ],
    };


    return (

        <section className={"" + props.tClass}>
            <div className="container-fluid">
                <div className="row justify-content-left">
                    <div className="col-12">
                        <SectionTitle title='Testimonial' subtitle="Our Patients Say About Us" />
                    </div>
                </div>
                <div className="row testimonial_slider">
                    <Slider {...settings}>
                        {testimonials.map((testitem, titem) => (
                            <div className="testimonial_card" key={titem}>
                                <div className="icon">
                                    <i className="flaticon-quote"></i>
                                </div>
                                <ul>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                    <li><i className="flaticon-star"></i></li>
                                </ul>
                                <p>{testitem.Des}</p>
                                <div className="ath">
                                    <div className="image">
                                        <img src={testitem.img} alt="" />
                                    </div>
                                    <div className="text">
                                        <h3>{testitem.title}</h3>
                                        <span>{testitem.sub}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
}

export default Testimonial;
